module.exports = __webpack_public_path__ + "static/media/img_01_xs.18b5e0ff.jpg";